import _ from "lodash";
import * as qs from "query-string";
import { getModelBands } from "helpers/Bands";
import { formatDate } from "helpers/DateHelper";
import { requestStatuses } from "helpers/RequestHelper";
import { isResultPass } from "helpers/RequestTestsHelper";
import { formatUsZip } from "helpers/BillingHelper";

export const getTicket = urlLocation => {
  const parsed = qs.parse(urlLocation.search);
  const { ticket } = parsed;
  return ticket;
};

export const prepareDocStatusArgs = newDocStatus => {
  return {
    args: {
      documentstatusid: newDocStatus
    }
  };
};

export const prepareTestResultArgs = testModule => {
  const {
    actualstartdate,
    actualenddate,
    requesttestpassedstatusid,
    planversion
    // requesttestconductinglabs
  } = testModule;

  const passed = isResultPass(requesttestpassedstatusid);

  // if no testing, should exclude dates
  const dates = {
    actualstartdate: passed ? formatDate(actualstartdate) : "",
    actualenddate: passed ? formatDate(actualenddate) : ""
  };

  // pre-format conducting labs
  // TODO: fix bug with overlooping
  // const labs = getConductLabsArgs(requesttestconductinglabs);

  return {
    args: {
      ...dates,
      planversion: _.trim(planversion),
      requesttestpassedstatusid
      // requesttestconductinglabs: labs
    }
  };
};

export const prepareModelArgs = request => {
  return {
    args: {
      modelnumber: _.trim(request.modelName),
      devicetypeid: request.deviceType,
      devicemodelbands: getModelBands(request.bands)
    }
  };
};

export const preparePocInfoArgs = (pocInfo, companyid) => {
  return {
    args: {
      firstname: _.trim(pocInfo.pocFirstName),
      lastname: _.trim(pocInfo.pocLastName),
      email: _.trim(pocInfo.pocEmail),
      phone: _.trim(pocInfo.pocPhone),
      companyid
    }
  };
};

export const prepareBillingPocArgs = (pocInfo, companyid) => {
  return {
    args: {
      firstname: _.trim(pocInfo.billingPocFirstName),
      lastname: _.trim(pocInfo.billingPocLastName),
      email: _.trim(pocInfo.billingPocEmail),
      phone: _.trim(pocInfo.billingPocPhone),
      billable: 1,
      companyid
    }
  };
};

export const prepareBillingAddressArgs = (billing, companyid) => {
  const { billingAddressCountry, billingAddressZip } = billing;
  const zipcode =
    billingAddressCountry === "US"
      ? formatUsZip(billingAddressZip)
      : _.trim(billingAddressZip);
  return {
    args: {
      name: _.trim(billing.billingAddressName),
      countrycode: billingAddressCountry,
      state: _.trim(billing.billingAddressState),
      zipcode,
      city: _.trim(billing.billingAddressCity),
      address1: _.trim(billing.billingAddressLine1),
      address2: _.trim(billing.billingAddressLine2),
      order: _.trim(billing.billingOrderNum),
      companyid
    }
  };
};

export const prepareRequestArgs = (request, billingId, modelId) => {
  return {
    args: {
      requesttypeid: request.type,
      devicemodelid: modelId,
      requesttestmodules: [{ testmoduleid: 1 }],
      primarylabid: request.cdmaLab,
      pocid: request.pocId,
      billingid: billingId,
      purchaseorder: _.trim(request.billingOrderNum)
    }
  };
};

export const prepareEcoRequestArgs = (request, billingid) => {
  return {
    args: {
      requesttypeid: request.type,
      devicemodelid: request.parentModelId,
      requesttestmodules: [{ testmoduleid: 1 }],
      primarylabid: request.cdmaLab,
      hwversion: _.trim(request.hwVersion),
      swversion: _.trim(request.swVersion),
      pocid: request.pocId,
      parentid: request.parentId,
      descriptionofchange: _.trim(request.descriptionOfChange),
      billingid,
      purchaseorder: _.trim(request.billingOrderNum)
    }
  };
};

export const prepareWithdrawnArgs = reason => {
  return {
    args: {
      requeststatusid: requestStatuses.requestWithdrawn,
      withdrawreason: _.trim(reason)
    }
  };
};

export const prepareUnwithdrawnArgs = status => {
  return {
    args: {
      requeststatusid: status
    }
  };
};

export const prepareDocumentApproveArgs = newDocStatus => {
  return {
    args: {
      documentstatusid: newDocStatus
    }
  };
};

export const prepareRequestApproveArgs = newReqStatus => {
  return {
    args: {
      requeststatusid: newReqStatus
    }
  };
};

export const prepareBillingArgs = request => {
  return {
    args: {
      addressid: Number(request.billingAddressId),
      pocid: Number(request.billingPocId)
    }
  };
};

export const setPaymentArgs = request => {
  const { payMethod, customPayMethod, payCheckNumber = "" } = request;
  const customMethod = _.trim(customPayMethod);
  const hasCustomMethod = _.size(customMethod) > 0;
  const paymentmethod = hasCustomMethod ? customMethod : payMethod;
  const checknumber = payMethod === "Check" ? payCheckNumber : "";
  return {
    args: {
      paymentmethod,
      paidat: formatDate(request.payDate),
      checknumber,
      paymentnote: request.payNote
    }
  };
};



// WEBPACK FOOTER //
// ./src/helpers/ArgsHelper.js